import Money from './models/money'

export const USER_ID_TOKEN = 'USER_ID_TOKEN'
export const SIX_WEBSITE_URL = 'https://www.six-invest.com.au'

export const APP_ROUTES = {
    DASHBOARD: '/',
    MORE: '/more',
    ABOUT_YOU: '/onboarding/about-you',
    NAME: '/onboarding/name',
    ADDRESS: '/onboarding/address',
    MOBILE_NUMBER: '/onboarding/mobile-number',
    MOBILE_VERIFICATION: '/onboarding/mobile-verification',
    SURVEY: '/onboarding/survey',
    TERMS_AND_CONDITIONS: '/onboarding/terms-and-conditions',
    ACCOUNT_TYPE: '/onboarding/account-type',
    KYC_INIT: '/onboarding/kyc-init',
    KYC: '/onboarding/kyc',
    BANK_ACCOUNT: '/onboarding/bank-account',
    ACCOUNT_CONFIRMATION: '/onboarding/account-confirmation',
    ACCOUNT_CREATED: '/onboarding/account-created',
    PROFILE: '/profile',
    REWARDS: '/rewards',
    SUPPORT: '/support',
    INVEST: '/invest',
    FIND_STOCKS: '/find-stocks',
    SECURITY: '/security',
    CAMPAIGNS: '/campaigns',
    RESEARCH: '/research',
    BLOGS: '/blogs',
    PORTFOLIO: '/portfolio',
    BUNDLES: '/bundles',
    ORDERS: '/orders',
    WALLET: '/wallet',
    CONFIRM_USER: '/auth/signup/confirm',
    SIGNUP: '/signup',
    SIGNUP_INVITE: '/signup/invite',
    APPLICATION_RESUME: '/application/resume',
    APPLICATION_CREATE: '/application/create',
    APPLICATION_KYC: '/application/kyc',
    APPLICATION_KYC_CONFIRM: '/application/kyc-confirm',

    // @deprecated - removed, redirected to /invest
    TRADING: '/trading',

    CLIENTS: '/clients',
    ACCOUNT: '/account',
    ACCOUNT_HOLDERS: '/account/holders',
    ACCOUNT_DETAILS: '/account/details',
    ACCOUNT_SETTINGS: '/account/settings',
    ACCOUNT_TRADE_CONFIRMATION: '/account/details/trade-confirmation',
    ACCOUNT_REGISTRATION_ADDRESS: '/account/details/registration-address',
    ACCOUNT_TFN: '/account/details/tfn',
}

export const API_ROUTES = {
    userSetup: '/api/user/setup',
    user: '/api/user',
    userTodos: '/api/user/todos/{}',
    userFeaturePromotionsViewed: '/api/user/feature-promotions/{}/viewed',
    userFeedback: '/api/user/feedback/{}',
    userRewards: '/api/user/rewards',
    /* Onboarding */
    accounts: '/api/accounts',
    accountSettings: '/api/accounts/{}',
    accountsParticipants: '/api/accounts/{}/participants',
    accountConfirm: '/api/accounts/{}/confirm',
    accountTradeConfirmationEmail: '/api/accounts/{}/trade-confirmation-email',
    accountRegistrationAddress: '/api/accounts/{}/registration-address',
    userName: '/api/user/name',
    userAccountType: '/api/user/account-type',
    userContactDetails: '/api/user/contact-details',
    userAddresses: '/api/user/addresses',
    userTfn: '/api/user/tfn',
    addressSearch: '/api/address-search/search',
    addressSearchById: '/api/address-search/address-id',
    survey: '/api/user/survey',
    usagePolicies: '/api/user/usage-policies/{}',
    acceptPolicy: '/api/user/accept-policy',
    acceptTerms: '/api/user/accept-terms',
    accountUsagePolicies: '/api/accounts/{}/usage-policies',
    contactSupport: '/api/user/contact-support',
    trackPasswordReset: '/api/analytics/password-reset',
    /* Mobile */
    userMobile: '/api/user/mobile',
    verifyMobileOtp: '/api/user/mobile/verify',
    sendMobileOtp: '/api/user/mobile/otp',
    /* KYC */
    accountsKyc: '/api/accounts/{}/kyc',
    accountsKycInit: '/api/accounts/{}/kyc/init',
    accountsParticipantsKycInit: '/api/accounts/{}/participants/{}/kyc/init',
    kycInit: '/api/user/kyc/init',
    kyc: '/api/user/kyc',
    requestStatusUpdate: '/api/user/kyc/request-status-update',
    /* Wallet */
    payId: '/api/user/wallet/deposit-options/payid',
    balance: '/api/user/wallet/balance',
    transactions: '/api/user/wallet/transactions',
    accountDetails: '/api/user/wallet/withdrawal-options/bank-account',
    withdraw: '/api/user/wallet/withdrawal-request',
    /* Market Data */
    topCompanies: '/api/market-data/asx/top-companies',
    securitiesSearch: '/api/market-data/securities',
    instrumentProfile: '/api/market-data/security/{}/profile',
    instrumentPrices: '/api/market-data/security/{}/prices',
    historicalPrices: '/api/market-data/security/{}/historical-prices',
    bundle: '/api/market-data/bundles/{}',
    bundles: '/api/market-data/bundles',
    recommendedSecurities: '/api/market-data/recommended-securities',
    trendingSecurities: '/api/market-data/trending-securities',
    securitiesByTag: '/api/market-data/securities-by-tag',
    securitiesByTags: '/api/market-data/securities-by-tags',
    etfsByTags: '/api/market-data/etfs-by-tags',
    /* Trading */
    tradingAccount: '/api/user/trading/account',
    buyOrder: '/api/user/buy-order',
    sellOrder: '/api/user/sell-order',
    cancelOrder: '/api/user/orders/{}/cancellation',
    listOrders: '/api/user/orders',
    listHoldings: '/api/user/holdings',
    getHoldingsHistory: '/api/user/holdings/history',
    getCompanyByCode: '/api/companies/{}',
    securitiesByOrderStats: '/api/security/buy-order-stats',
    /* Campaigns */
    campaignsList: '/api/campaigns/list',
    campaignDetails: '/api/campaigns/details/{}',
    campaignSubscriptions: '/api/user/campaigns/subscriptions',
    campaignSubscribe: '/api/user/campaigns/{}/subscribe',
    campaignUnsubscribe: '/api/user/campaigns/{}/unsubscribe',
    campaignPledge: '/api/user/campaigns/{}/{}/pledges',
    campaignUserPledgeList: '/api/user/pledges',
    agencyAgreements: '/api/user/campaigns/{}/{}/agency-agreements',
    agencyAgreement: '/api/user/campaigns/agency-agreement',
    /* Blogs */
    blogs: '/api/blogs',
    blog: '/api/blogs/{}',
    /* Research */
    esgProfile: '/api/esg/profile/{}',
    esgTerms: '/api/esg/terms',
}

export const USAGE_POLICIES = {
    SIGNUP_TERMS: 'signup-terms',
    SIX_TERMS: 'six-terms',
    FINCLEAR_TERMS: 'finclear-terms',
    AGENCY_AGREEMENT: 'agency-agreement',
    MONOOVA_TERMS: 'monoova-terms',
    FRANKIE_ONE_TERMS: 'frankieone-terms',
    ADVISER_TERMS: 'adviser-terms',
} as const

export const KYC_STATUS = {
    UNVERIFIED: 'UNVERIFIED',
    INITIATED: 'INITIATED',
    RE_INITIATED: 'RE_INITIATED',
    UNDER_VERIFICATION: 'UNDER_VERIFICATION',
    VERIFICATION_SUCCESS: 'VERIFICATION_SUCCESS',
    VERIFICATION_FAILED: 'VERIFICATION_FAILED',
} as const

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const

export const MIN_TRADE_FEE = Money.of(9.9)
export const TRADE_FEE_PERCENTAGE = 0.11

export const ORDER_EXPIRY = {
    VALID_TILL_EOD: 'End of day',
    VALID_TILL_CANCEL: 'Good till cancelled',
    VALID_FOR_DAYS_7: '7 days',
    VALID_FOR_DAYS_15: '15 days',
    VALID_FOR_DAYS_30: '30 days',
}

export const ORDER_EXPIRY_MAPPING = {
    'Day Only': 'VALID_TILL_EOD',
    'Till Cancel': 'VALID_TILL_CANCEL',
    'Till Date': 'TILL_DATE',
}

export const ORDER_TYPE = {
    LIMIT: 'Limit',
    MARKET_TO_LIMIT: 'Market',
}

export const ORDER_ACTION = {
    BUY: 'Buy',
    SELL: 'Sell',
}

export const SWIFTID_PATHS = {
    CREATE_PATH: 'applications/{type}/primaryapplicant?ipaId={id}',
    RESUME_PATH: 'applications/resume/{id}',
}

export const ORDER_FAILURE_CODES = {
    MAX_TRADE_AMOUNT_EXCEEDED: {
        title: 'Order failed',
        description: 'Orders greater than $250,000 are not supported. Please try again with a reduced amount.',
    },
    MIN_TRADE_AMOUNT: {
        title: 'Order failed',
        description:
            'The total amount for this order is below the minimum required. Please adjust the number of units or price and try again.',
    },
    MARKET_CLOSED: {
        title: 'Market Closed',
        description:
            'This order could not be executed because the market is currently closed. Orders can only be placed during market hours.',
    },
    PRICE_OVERLAP: {
        title: 'Order price overlap',
        description: 'Your order price overlapped with best bid price, please try again.',
    },
    PRICE_UNAVAILABLE: {
        title: 'Order failed',
        description: 'Your order failed, please try again or get in touch with the team for assistance.',
    },
    PRICE_MISMATCH: {
        title: 'Order failed',
        description: 'Your order failed, please try again or get in touch with the team for assistance.',
    },
    REFERENCE_PRICE_ERROR: {
        title: 'Order failed',
        description: 'Your order failed, please try again or get in touch with the team for assistance.',
    },
    LIMIT_ORDER_REQUIRED: {
        title: 'Order failed',
        description:
            'Your market order failed, please try again by submitting a limit order or a market order when the ASX is open.',
    },
    INSUFFICIENT_UNITS: {
        title: 'Not enough units available',
        description: 'Not enough units available, please try again later.',
    },
    NO_MARKET_FOR_ORDER_TYPE: {
        title: 'Order failed',
        description:
            'Your market order failed, please try again by submitting a limit order or a market order when the ASX is open.',
    },
    SYSTEM_ERROR: {
        title: 'Temporary server error',
        description: 'Your order failed due to a temporary server error, please try again.',
    },
    INVALID_EXPIRY_DATE: {
        title: 'Order failed',
        description: 'Your order failed, please try again with a different expiry period.',
    },
    INVALID_TIME_VALIDITY: {
        title: 'Order failed',
        description: 'Your order failed, please try again with a different expiry period.',
    },
    ORDER_EXPIRED: {
        title: 'Order expired',
        description: 'Your order has expired and was not executed. Please place a new order.',
    },
} as const
